import React, { useState } from 'react';

import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import { EMRoutingContextInterface } from '@om-fe/core/core/routing/utils';
import { DisciplineLiveStatus } from '@om-fe/models';
import getConfig, { BannerMatrixConfig, OMFE2ConfigModel, MarketsHeaderOptions } from '@om-fe/core/utils/config';
import { PlatformTypes, isBrowser } from '@om-fe/utils';

import MatchListSelector from '../../../match-list/match-list-selector';
import { MatchListCommon, FilteredMarketGroupsOverview } from '../../../match-list/utils/match-list-models';
import { MatchListItemLayout } from '../../../match-list/utils/match-list.constants';
import TopBetsMatchList, { TopBetsMatchListPublicProps } from './top-bets-list';
import { TimeRangeType } from '../../utils/top-bets.constants';
import { MatchListAddMoreAnchor } from '../../../match-list/match-list';

export interface TopBetsMatchListSelectorPublicProps extends MatchListCommon {
    readonly instanceId: string;
    readonly disciplineId: string;
    readonly redirectAnchor?: MatchListAddMoreAnchor;
    readonly itemLayout?: MatchListItemLayout;
    readonly liveStatus: DisciplineLiveStatus;
    readonly marketsHeaderOptions: MarketsHeaderOptions;
    readonly marketGroupsOverviewNumber?: number;
    readonly hasMarketSelector: boolean;
    readonly showMatchListHeader: boolean;
    readonly showMarketInMatchListGroupHeader: boolean;
    readonly deviceType?: PlatformTypes;
    readonly showMarketSelectorHeader?: boolean;
    readonly timeRange: string;
    readonly locationId?: string;
    readonly categoryId?: string;
    readonly isTopBets?: boolean;
    readonly isCategory?: boolean;
    readonly timeRangeType?: TimeRangeType;
    readonly timeRangeValue?: string;
    readonly groupOverviewData?: string[];
    readonly filteredMarketGroupsOverview?: Record<string, FilteredMarketGroupsOverview>;
    readonly filteredMarketGroupsOverviewList?: string[];
}

type TopBetsMatchListSelectorProps = TopBetsMatchListSelectorPublicProps
    & TopBetsMatchListPublicProps
    & I18nContextInterface
    & EMRoutingContextInterface;

const globalConfig: OMFE2ConfigModel = getConfig();
const bannerMatrixConfig: BannerMatrixConfig | undefined = globalConfig.bannerMatrix;

function TopBetsMatchListSelectorMarketGroup(
    {
        instanceId,
        disciplineId,
        liveStatus,
        limitNumberOfEvents,
        mainMarketsLimit,
        marketsHeaderOptions,
        hasMarketSelector,
        showMatchListHeader,
        showMarketInMatchListGroupHeader,
        groupOverviewData,
        filteredMarketGroupsOverview,
        filteredMarketGroupsOverviewList,
        deviceType,
        itemLayout,
        showMarketSelectorHeader,
        timeRange,
        locationId,
        categoryId,
        isTopBets,
        isCategory,
        timeRangeType,
        timeRangeValue,
    }: TopBetsMatchListSelectorProps,
) {
    const [groupOverview, setGroupOverview] = useState<string | undefined>(groupOverviewData);

    const selectGroupsOverview = (item: string) => {

        const listSelected = mainMarketsLimit === 1
            ? item
            : filteredMarketGroupsOverviewList?.slice(0, mainMarketsLimit - 1)
                .concat(item)
                .join(',');
                setGroupOverview(listSelected);
    }

    if (groupOverview === '' && bannerMatrixConfig?.showOnFooter && isBrowser()) {
        document.querySelector(`#BannerFooter`)?.classList.remove('BannerWidgetBannerHidden');
    }

    if (showMarketSelectorHeader && filteredMarketGroupsOverviewList.length) {

        return <TopBetsMatchList
                disciplineId={disciplineId}
                instanceId={instanceId}
                liveStatus={liveStatus}
                limitNumberOfEvents={limitNumberOfEvents}
                marketsHeaderOptions={marketsHeaderOptions}
                mainMarketsLimit={mainMarketsLimit}
                groupOverview={groupOverview}
                hasMarketSelector={filteredMarketGroupsOverviewList.length ? hasMarketSelector : false}
                itemLayout={itemLayout}
                selectGroupsOverview={selectGroupsOverview}
                filteredMarketGroupsOverview={filteredMarketGroupsOverview}
                filteredMarketGroupsOverviewList={filteredMarketGroupsOverviewList}
                isHasDrawer={true}
                deviceType={deviceType}
                showMatchListHeader={showMatchListHeader}
                showMarketInMatchListGroupHeader={showMarketInMatchListGroupHeader}
                timeRange={timeRange}
                isTopBets={isTopBets}
                locationId={locationId}
                categoryId={categoryId}
                isCategory={isCategory}
                timeRangeType={timeRangeType}
                timeRangeValue={timeRangeValue}
            />
    }
    
    return (
        <>
            {!!filteredMarketGroupsOverviewList.length && (
                    <MatchListSelector
                        selectGroupsOverview={selectGroupsOverview}
                        filteredMarketGroupsOverview={filteredMarketGroupsOverview}
                        filteredMarketGroupsOverviewList={filteredMarketGroupsOverviewList}
                        marketSelected={groupOverview}
                        mainMarketsLimit={mainMarketsLimit}
                        isHasDrawer={true}
                        deviceType={deviceType}
                    />
                )
            }
            <TopBetsMatchList
                disciplineId={disciplineId}
                instanceId={instanceId}
                liveStatus={liveStatus}
                limitNumberOfEvents={limitNumberOfEvents}
                marketsHeaderOptions={marketsHeaderOptions}
                mainMarketsLimit={mainMarketsLimit}
                groupOverview={groupOverview}
                hasMarketSelector={hasMarketSelector}
                showMatchListHeader={showMatchListHeader}
                showMarketInMatchListGroupHeader={showMarketInMatchListGroupHeader}
                itemLayout={itemLayout}
                timeRange={timeRange}
                isTopBets={isTopBets}
                locationId={locationId}
                categoryId={categoryId}
                isCategory={isCategory}
                timeRangeType={timeRangeType}
                timeRangeValue={timeRangeValue}
            />
        </>
    );
}

export default TopBetsMatchListSelectorMarketGroup;